import Markdown from '.';

/** @type {UICore.ComponentMeta} */
const MarkdownComponentMeta = {
  id: 'markdown',
  name: 'Markdown',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-markdown-1_1636364537922.png',
  category: '展示',
  component: Markdown,
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'align',
      type: 'string',
      enum: [{
        label: '左对齐',
        value: 'left'
      }, {
        label: '居中',
        value: 'center'
      }, {
        label: '右对齐',
        value: 'right'
      }]
    }, {
      id: 'source',
      type: 'string',
      default: '在属性面板编写内容\n\n*支持 Markdown*',
      required: true,
      ui: {
        settings: {
          multipleLine: true
        }
      }
    }, {
      id: 'allowHtml',
      type: 'boolean',
      default: false,
      title: '允许使用 HTML'
    }, {
      id: 'openInNewWindow',
      type: 'boolean',
      default: false,
      title: '运行时链接打开为新页面'
    }, {
      id: 'breaks',
      type: 'boolean',
      default: false,
      description: '标准 Markdown 渲染器中，文字段落内的换行符是不会生效的',
      title: '遇到回车必须换行'
    }]
  },
  bindingAction({
    comp,
    dataPath
  }) {
    // eslint-disable-next-line no-param-reassign
    comp.props.source = `{{ ${dataPath} }}`;
  }
};
export default MarkdownComponentMeta;